import { jsx as _jsx } from "react/jsx-runtime";
import { EditableDate } from "@air/component-editable-date";
import { memo } from "react";
import { CUSTOM_FIELD_DATE } from "~/constants/testIDs";
export const CustomFieldDateInput = /*#__PURE__*/ memo((param)=>{
    let { field, onBlur, onChange, canEditCustomFields, ...rest } = param;
    return /*#__PURE__*/ _jsx(EditableDate, {
        ...rest,
        onChange: (date)=>{
            const dateValue = date === null || date === void 0 ? void 0 : date.toISOString();
            if (dateValue === field.dateValue) return;
            onChange(date);
        },
        onEditingStateChange: (isEditing)=>{
            if (!isEditing) {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
            }
        },
        "data-testid": "".concat(CUSTOM_FIELD_DATE, "-").concat(field.name),
        size: "large",
        name: field.id,
        dateValue: field.dateValue,
        placeholder: canEditCustomFields ? "Add a date" : "None",
        readOnly: !canEditCustomFields,
        showCalendarIcon: false,
        buttonClassName: "rounded-4 bg-transparent p-1.5 transition-colors border border-grey-5 hover:border-grey-7 hover:bg-grey-2 pl-2"
    });
});
CustomFieldDateInput.displayName = "CustomFieldDateInput";
